module.exports = __webpack_public_path__ + "img/header-weddingRingsBestseller.b705f1c.jpg";